export default function withDelimiter(val) {
  if (typeof val !== 'number' && typeof val !== 'string') return null
  const arr = String(val).split('.')
  arr[0] = arr[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  return arr.join('.')
}
